// extracted by mini-css-extract-plugin
export default {"container":"NotFound_container__1fusd","message":"NotFound_message__obVKA"};